(function () {
  'use strict';

  var root = document.querySelector('.ct[id^="ct-"]');
  if (!root) return;

  var maxSlots = parseInt(root.getAttribute('data-max-slots') || '4', 10);

  var brandNames = (root.getAttribute('data-brand-names') || '')
    .split(',')
    .map(function (s) { return s.trim(); })
    .filter(Boolean);

  var searchPlaceholder =
    root.getAttribute('data-search-placeholder') ||
    'Search products to add…';

  var products = [];
  var labels = {};

  try {
    var productDataEl = root.querySelector('[data-product-data]');
    if (productDataEl) {
      products = JSON.parse(productDataEl.textContent || '[]');
    }
  } catch (e) {
    console.error(
      'Comparison tool: failed to parse product data',
      e
    );
  }

  try {
    var labelsEl = root.querySelector('[data-attribute-labels]');
    if (labelsEl) {
      labels = JSON.parse(labelsEl.textContent || '{}');
    }
  } catch (e) {
    console.error(
      'Comparison tool: failed to parse labels',
      e
    );
  }

  var LOSS_LEVELS = [
    'mild',
    'moderate',
    'severe',
    'profound'
  ];

  /* =========================================================
     HELPERS
     ========================================================= */

  function lossLevelsFor(product) {
    var tags = (product.tags || []).map(function (t) {
      return String(t).toLowerCase();
    });

    return LOSS_LEVELS.filter(function (level) {
      return tags.indexOf('hearing-' + level) !== -1;
    });
  }

  function lossLevelLabel(product) {
    var levels = lossLevelsFor(product);

    if (!levels.length) return null;

    return levels.map(function (l) {
      return l.charAt(0).toUpperCase() + l.slice(1);
    }).join(', ');
  }

  function formatMoney(amount) {
    var n = Number(amount) || 0;

    return '$' + n.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function escapeHtml(str) {
    return String(str || '').replace(
      /[&<>"']/g,
      function (s) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[s];
      }
    );
  }

  /* =========================================================
     STATE
     ========================================================= */

  var selected = [];
  var slotsEl = root.querySelector('[data-slots]');
  var activeSearchSlot = null;
  var activeSearchPanel = null;
  var activeSearchAnchor = null;

  /* =========================================================
     COPY CT VARIABLES TO BODY SEARCH PANEL
     Because search panel lives inside <body>
     ========================================================= */

  function copyCtVariables(panel) {
    var computed = window.getComputedStyle(root);

    var vars = [
      '--ct-bg',
      '--ct-ink',
      '--ct-ink-soft',
      '--ct-teal',
      '--ct-teal-dark',
      '--ct-mint',
      '--ct-line',
      '--ct-coral',
      '--ct-white',
      '--ct-gold',
      '--ct-radius',
      '--ct-ease',
      '--ct-shadow-sm',
      '--ct-shadow-md',
      '--ct-shadow-lg'
    ];

    vars.forEach(function (name) {
      var value = computed.getPropertyValue(name);

      if (value) {
        panel.style.setProperty(name, value);
      }
    });

    panel.style.setProperty(
      'font-family',
      computed.fontFamily
    );
  }

  /* =========================================================
     SLOTS UI
     ========================================================= */

  function renderSlots() {
    if (!slotsEl) return;

    slotsEl.innerHTML = '';

    for (var i = 0; i < maxSlots; i++) {
      var product = selected[i];

      var slot = document.createElement('div');

      if (product) {
        slot.className = 'ct__slot';

        var savePct =
          (
            product.compareAtPrice > product.price &&
            product.compareAtPrice > 0
          )
            ? Math.round(
                (product.compareAtPrice - product.price) *
                100 /
                product.compareAtPrice
              )
            : 0;

        slot.innerHTML =
          '<button type="button" class="ct__slot-remove" ' +
          'data-remove-idx="' + i + '" aria-label="Remove">' +
          '×' +
          '</button>' +

          (
            product.image
              ? '<img src="' + product.image +
                '" alt="' + escapeHtml(product.title) +
                '" loading="lazy">'
              : ''
          ) +

          '<div class="ct__slot-body">' +

          '<div class="ct__slot-title">' +
          escapeHtml(product.title) +
          '</div>' +

          '<div class="ct__slot-price">' +
          formatMoney(product.price) +

          (
            savePct > 0
              ? ' <span style="color:var(--ct-teal)">−' +
                savePct +
                '%</span>'
              : ''
          ) +

          '</div>' +

          '</div>';

      } else {
        slot.className =
          'ct__slot ct__slot--empty';

        slot.setAttribute(
          'data-add-idx',
          String(i)
        );

        slot.innerHTML =
          '<span>+ Add product</span>';
      }

      slotsEl.appendChild(slot);
    }

    /* Remove */
    slotsEl
      .querySelectorAll('[data-remove-idx]')
      .forEach(function (btn) {

        btn.addEventListener('click', function () {

          selected[
            Number(
              btn.getAttribute('data-remove-idx')
            )
          ] = null;

          selected = selected.filter(Boolean);

          clearPresetActive();

          renderSlots();
          renderTable();
        });
      });

    /* Add */
    slotsEl
      .querySelectorAll('[data-add-idx]')
      .forEach(function (slotEl) {

        slotEl.addEventListener(
          'click',
          function () {

            openSearchPanel(
              slotEl,
              Number(
                slotEl.getAttribute('data-add-idx')
              )
            );
          }
        );
      });
  }

  /* =========================================================
     SEARCH PANEL
     ========================================================= */

  function openSearchPanel(slotEl, idx) {

    closeSearchPanel();

    activeSearchSlot = idx;
    activeSearchAnchor = slotEl;

    var panel = document.createElement('div');

    panel.className = 'ct__search-panel';

    /*
      Keep it outside .ct so ancestor overflow cannot clip it.
    */

    panel.innerHTML =
      '<div class="ct__search-input-row">' +

      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="8" ' +
      'stroke="currentColor" stroke-width="2"/>' +
      '<line x1="21" y1="21" x2="16.65" y2="16.65" ' +
      'stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round"/>' +
      '</svg>' +

      '<input type="text" ' +
      'class="ct__search-input" ' +
      'placeholder="' +
      escapeHtml(searchPlaceholder) +
      '" autocomplete="off">' +

      '<button type="button" ' +
      'class="ct__search-close" ' +
      'aria-label="Close">×</button>' +

      '</div>' +

      '<div class="ct__search-results"></div>';

    /*
      IMPORTANT:
      Fixed position is intentional.
      Panel is attached to body.
    */

    panel.style.position = 'fixed';
    panel.style.margin = '0';
    panel.style.visibility = 'hidden';

    document.body.appendChild(panel);

    activeSearchPanel = panel;

    /*
      Give panel the same CSS variables as .ct
    */
    copyCtVariables(panel);

    /*
      First render content.
    */
    var input =
      panel.querySelector('.ct__search-input');

    var results =
      panel.querySelector('.ct__search-results');

    function renderResults(query) {

      var q = String(query || '')
        .trim()
        .toLowerCase();

      var matches = products
        .filter(function (p) {

          var title =
            String(p.title || '').toLowerCase();

          var vendor =
            String(p.vendor || '').toLowerCase();

          return (
            !q ||
            title.indexOf(q) !== -1 ||
            vendor.indexOf(q) !== -1
          );
        })
        .slice(0, 20);

      if (!matches.length) {

        results.innerHTML =
          '<div class="ct__search-empty">' +
          'No products found' +
          '</div>';

        return;
      }

      results.innerHTML =
        matches.map(function (p, i) {

          return (
            '<div class="ct__search-item" ' +
            'data-idx="' + i + '">' +

            (
              p.image
                ? '<img src="' + p.image +
                  '" alt="" loading="lazy">'
                : ''
            ) +

            '<div class="ct__search-item-body">' +

            '<span class="ct__search-item-title">' +
            escapeHtml(p.title) +
            '</span>' +

            '<span class="ct__search-item-price">' +
            formatMoney(p.price) +
            '</span>' +

            '</div>' +

            '</div>'
          );
        }).join('');

      results
        .querySelectorAll('[data-idx]')
        .forEach(function (item) {

          item.addEventListener(
            'mousedown',
            function (e) {

              e.preventDefault();

              var product =
                matches[
                  Number(
                    item.getAttribute('data-idx')
                  )
                ];

              selected[idx] = product;

              clearPresetActive();

              closeSearchPanel();

              renderSlots();
              renderTable();
            }
          );
        });
    }

    renderResults('');

    /*
      Search
    */
    input.addEventListener(
      'input',
      function () {
        renderResults(input.value);
      }
    );

    /*
      Close
    */
    panel
      .querySelector('.ct__search-close')
      .addEventListener(
        'mousedown',
        function (e) {

          e.preventDefault();

          closeSearchPanel();
        }
      );

    /*
      Position AFTER content is rendered.
      This gives us the REAL panel height.
    */

    requestAnimationFrame(function () {

      positionPanel(
        panel,
        slotEl
      );

      panel.style.visibility = 'visible';

      requestAnimationFrame(function () {

        /*
          Recalculate once more after browser paint.
        */
        positionPanel(
          panel,
          slotEl
        );

        input.focus();
      });
    });

    window.addEventListener(
      'scroll',
      repositionActivePanel,
      true
    );

    window.addEventListener(
      'resize',
      repositionActivePanel
    );
  }

  /* =========================================================
     SMART PANEL POSITIONING
     ========================================================= */

  function positionPanel(panel, slotEl) {

    if (!panel || !slotEl) return;

    var rect =
      slotEl.getBoundingClientRect();

    var viewportWidth =
      window.innerWidth;

    var viewportHeight =
      window.innerHeight;

    /*
      Responsive width
    */

    var panelWidth;

    if (viewportWidth <= 420) {

      panelWidth =
        Math.max(
          0,
          viewportWidth - 16
        );

    } else if (viewportWidth <= 700) {

      panelWidth =
        Math.max(
          0,
          viewportWidth - 20
        );

    } else {

      panelWidth =
        Math.min(
          380,
          viewportWidth - 24
        );
    }

    panel.style.width =
      panelWidth + 'px';

    panel.style.maxWidth =
      panelWidth + 'px';

    /*
      Remove transform completely.
      We calculate the final top ourselves.
    */

    panel.style.transform = 'none';

    /*
      Get REAL panel height after width is applied.
    */

    var panelRect =
      panel.getBoundingClientRect();

    var panelHeight =
      panelRect.height;

    /*
      Safety fallback
    */

    if (!panelHeight || panelHeight < 1) {
      panelHeight = 360;
    }

    /*
      Small viewport safety
    */

    var edge = 10;

    if (viewportWidth <= 700) {
      edge = 8;
    }

    /*
      MOBILE
      Center the panel horizontally.
    */

    var left;

    if (viewportWidth <= 700) {

      left =
        Math.max(
          edge,
          (viewportWidth - panelWidth) / 2
        );

    } else {

      /*
        Desktop:
        Try aligning to slot's left edge.
      */

      left = rect.left;

      /*
        Prevent right overflow.
      */

      if (
        left + panelWidth >
        viewportWidth - edge
      ) {
        left =
          viewportWidth -
          panelWidth -
          edge;
      }

      /*
        Prevent left overflow.
      */

      if (left < edge) {
        left = edge;
      }
    }

    /*
      VERTICAL POSITION
    */

    var gap = 8;

    var spaceBelow =
      viewportHeight -
      rect.bottom;

    var spaceAbove =
      rect.top;

    var top;

    /*
      Prefer BELOW when enough space exists.
    */

    if (
      spaceBelow >=
      Math.min(
        panelHeight + gap,
        260
      )
    ) {

      top =
        rect.bottom + gap;

    } else if (
      spaceAbove >=
      Math.min(
        panelHeight + gap,
        260
      )
    ) {

      /*
        Open ABOVE.
        No transform required.
      */

      top =
        rect.top -
        panelHeight -
        gap;

    } else {

      /*
        Neither side has enough space.
        Choose the side with more room.
      */

      if (spaceBelow >= spaceAbove) {

        top =
          rect.bottom + gap;

      } else {

        top =
          rect.top -
          panelHeight -
          gap;
      }
    }

    /*
      FINAL VIEWPORT CLAMP
      This is the important part.

      It guarantees:
      top >= edge
      bottom <= viewport - edge
    */

    var maxTop =
      Math.max(
        edge,
        viewportHeight -
        panelHeight -
        edge
      );

    top =
      Math.max(
        edge,
        Math.min(
          top,
          maxTop
        )
      );

    /*
      FINAL horizontal clamp
    */

    var maxLeft =
      Math.max(
        edge,
        viewportWidth -
        panelWidth -
        edge
      );

    left =
      Math.max(
        edge,
        Math.min(
          left,
          maxLeft
        )
      );

    /*
      Apply final values.
    */

    panel.style.left =
      Math.round(left) + 'px';

    panel.style.top =
      Math.round(top) + 'px';

    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
  }

  /* =========================================================
     CLOSE SEARCH PANEL
     ========================================================= */

  function closeSearchPanel() {

    if (activeSearchPanel) {

      activeSearchPanel.remove();

      activeSearchPanel = null;
    }

    activeSearchSlot = null;
    activeSearchAnchor = null;

    window.removeEventListener(
      'scroll',
      repositionActivePanel,
      true
    );

    window.removeEventListener(
      'resize',
      repositionActivePanel
    );
  }

  /* =========================================================
     REPOSITION
     ========================================================= */

  function repositionActivePanel() {

    if (
      !activeSearchPanel ||
      activeSearchSlot === null ||
      !activeSearchAnchor
    ) {
      return;
    }

    /*
      If the anchor was removed from DOM,
      close safely.
    */

    if (!document.documentElement.contains(
      activeSearchAnchor
    )) {

      closeSearchPanel();
      return;
    }

    positionPanel(
      activeSearchPanel,
      activeSearchAnchor
    );
  }

  /* =========================================================
     OUTSIDE CLICK
     ========================================================= */

  document.addEventListener(
    'click',
    function (e) {

      if (
        activeSearchSlot !== null &&
        activeSearchPanel &&
        !e.target.closest('.ct__search-panel') &&
        !e.target.closest('[data-add-idx]')
      ) {
        closeSearchPanel();
      }
    }
  );

  /* =========================================================
     PRESETS
     ========================================================= */

  function clearPresetActive() {

    root
      .querySelectorAll('[data-preset]')
      .forEach(function (b) {

        b.removeAttribute('data-active');
      });
  }

  function applyPreset(name, btn) {

    clearPresetActive();

    if (btn) {
      btn.setAttribute(
        'data-active',
        'true'
      );
    }

    var picks = [];

    if (name === 'bestsellers') {

      picks =
        products.slice(
          0,
          maxSlots
        );

    } else if (
      name.indexOf('loss-') === 0
    ) {

      var level =
        name.replace(
          'loss-',
          ''
        );

      picks =
        products
          .filter(function (p) {

            return (
              lossLevelsFor(p)
                .indexOf(level) !== -1
            );
          })
          .slice(
            0,
            maxSlots
          );

    } else if (name === 'brands') {

      brandNames.forEach(
        function (brand) {

          if (
            picks.length >=
            maxSlots
          ) {
            return;
          }

          var match =
            products.find(
              function (p) {

                return (
                  String(
                    p.vendor || ''
                  ).toLowerCase() ===
                  brand.toLowerCase()
                );
              }
            );

          if (match) {
            picks.push(match);
          }
        }
      );
    }

    selected = picks;

    renderSlots();
    renderTable();
  }

  root
    .querySelectorAll('[data-preset]')
    .forEach(function (btn) {

      btn.addEventListener(
        'click',
        function () {

          applyPreset(
            btn.getAttribute(
              'data-preset'
            ),
            btn
          );
        }
      );
    });

  /* =========================================================
     TABLE
     ========================================================= */

  var tableWrap =
    root.querySelector(
      '[data-table-wrap]'
    );

  var tableHead =
    root.querySelector(
      '[data-table-head]'
    );

  var tableBody =
    root.querySelector(
      '[data-table-body]'
    );

  var emptyState =
    root.querySelector(
      '[data-empty-state]'
    );

  var showWhoRow =
    root.getAttribute(
      'data-show-who'
    ) !== 'false';

  /* =========================================================
     PARSE SPECS
     ========================================================= */

  function parseSpecs(raw) {

    if (!raw) return [];

    return raw
      .split('||')
      .map(function (row) {

        var parts =
          row.split('::');

        return {
          label:
            (parts[0] || '').trim(),

          value:
            (parts[1] || '').trim()
        };
      })
      .filter(function (r) {

        return r.label;
      });
  }

  function parseWhoList(raw) {

    if (!raw) return [];

    return raw
      .split('||')
      .map(function (s) {

        return s.trim();
      })
      .filter(Boolean);
  }

  function textCell(val) {

    return val
      ? escapeHtml(val)
      : '<span class="ct__dash">—</span>';
  }

  /* =========================================================
     PRICE
     ========================================================= */

  function renderPriceCell(p) {

    var savePct =
      (
        p.compareAtPrice > p.price &&
        p.compareAtPrice > 0
      )
        ? Math.round(
            (p.compareAtPrice - p.price) *
            100 /
            p.compareAtPrice
          )
        : 0;

    var html =
      '<span class="ct__price-value">' +
      formatMoney(p.price) +
      '</span>';

    if (
      p.compareAtPrice >
      p.price
    ) {

      html +=
        '<span class="ct__price-compare">' +
        formatMoney(
          p.compareAtPrice
        ) +
        '</span>';
    }

    if (savePct > 0) {

      html +=
        '<br><span class="ct__price-save">' +
        'Save ' +
        savePct +
        '%' +
        '</span>';
    }

    return html;
  }

  /* =========================================================
     FEATURE LIST
     ========================================================= */

  function renderListCell(items) {

    if (
      !items ||
      !items.length
    ) {
      return '<span class="ct__dash">—</span>';
    }

    return (
      '<ul class="ct__features-list">' +

      items.map(
        function (f) {

          return (
            '<li>' +
            escapeHtml(f) +
            '</li>'
          );
        }
      ).join('') +

      '</ul>'
    );
  }

  /* =========================================================
     TABLE RENDER
     ========================================================= */

  function renderTable() {

    if (
      selected.length < 2
    ) {

      tableWrap.hidden = true;
      emptyState.hidden = false;

      return;
    }

    tableWrap.hidden = false;
    emptyState.hidden = true;

    var specsByProduct =
      selected.map(
        function (p) {

          return parseSpecs(
            p.specsRaw
          );
        }
      );

    var specLabelOrder = [];

    specsByProduct.forEach(
      function (specs) {

        specs.forEach(
          function (s) {

            if (
              specLabelOrder
                .indexOf(
                  s.label
                ) === -1
            ) {

              specLabelOrder.push(
                s.label
              );
            }
          }
        );
      }
    );

    var headHtml =
      '<tr>' +
      '<th scope="col"></th>' +

      selected.map(
        function (p) {

          return (
            '<th scope="col" class="ct__col-head">' +

            '<div class="ct__col-card">' +

            (
              p.image
                ? '<img src="' +
                  p.image +
                  '" alt="' +
                  escapeHtml(
                    p.title
                  ) +
                  '">'
                : ''
            ) +

            (
              p.vendor
                ? '<span class="ct__col-vendor">' +
                  escapeHtml(
                    p.vendor
                  ) +
                  '</span>'
                : ''
            ) +

            '<span class="ct__col-title">' +
            escapeHtml(
              p.title
            ) +
            '</span>' +

            '<a class="ct__col-link" href="' +
            escapeHtml(
              p.url
            ) +
            '">' +
            'View product' +
            '</a>' +

            '</div>' +

            '</th>'
          );
        }
      ).join('') +

      '</tr>';

    tableHead.innerHTML =
      headHtml;

    var rowsHtml = '';

    /* Price */
    rowsHtml +=
      '<tr>' +

      '<th scope="row">' +
      escapeHtml(
        labels.price ||
        'Price'
      ) +
      '</th>' +

      selected.map(
        function (p) {

          return (
            '<td>' +
            renderPriceCell(p) +
            '</td>'
          );
        }
      ).join('') +

      '</tr>';

    /* Brand */
    rowsHtml +=
      '<tr>' +

      '<th scope="row">' +
      escapeHtml(
        labels.vendor ||
        'Brand'
      ) +
      '</th>' +

      selected.map(
        function (p) {

          return (
            '<td>' +
            textCell(
              p.vendor
            ) +
            '</td>'
          );
        }
      ).join('') +

      '</tr>';

    /* Hearing loss */
    rowsHtml +=
      '<tr>' +

      '<th scope="row">' +
      escapeHtml(
        labels.lossLevel ||
        'Best for hearing loss'
      ) +
      '</th>' +

      selected.map(
        function (p) {

          return (
            '<td>' +
            textCell(
              lossLevelLabel(p)
            ) +
            '</td>'
          );
        }
      ).join('') +

      '</tr>';

    /* Ideal for */
    if (showWhoRow) {

      rowsHtml +=
        '<tr>' +

        '<th scope="row">' +
        escapeHtml(
          labels.whoRaw ||
          'Ideal for'
        ) +
        '</th>' +

        selected.map(
          function (p) {

            return (
              '<td>' +
              renderListCell(
                parseWhoList(
                  p.whoRaw
                )
              ) +
              '</td>'
            );
          }
        ).join('') +

        '</tr>';
    }

    /* Dynamic specs */
    specLabelOrder.forEach(
      function (label) {

        rowsHtml +=
          '<tr>' +

          '<th scope="row">' +
          escapeHtml(label) +
          '</th>' +

          specsByProduct.map(
            function (specs) {

              var match =
                specs.find(
                  function (s) {

                    return (
                      s.label ===
                      label
                    );
                  }
                );

              return (
                '<td>' +
                textCell(
                  match
                    ? match.value
                    : null
                ) +
                '</td>'
              );
            }
          ).join('') +

          '</tr>';
      }
    );

    tableBody.innerHTML =
      rowsHtml;
  }

  /* =========================================================
     INIT
     ========================================================= */

  renderSlots();
  renderTable();

  if (products.length) {

    applyPreset(
      'bestsellers',
      root.querySelector(
        '[data-preset="bestsellers"]'
      )
    );
  }

})();